<template>
  <apexchart
    v-if="series"
    type="line"
    width="100%"
    height="350"
    :options="chartOptions"
    :series="series"
  ></apexchart>

  <v-skeleton-loader v-else class="mx-auto" type="image"></v-skeleton-loader>
</template>

<script>
import axios from "@/plugins/axios";
import moment from "moment";
export default {
  data() {
    return {
      error: null,
      chartOptions: null,
      series: [],
    };
  },
  methods: {
    getChartData() {
      let that = this;
      axios.get("/api/v1/ticket/monthly-chart").then((response) => {
        // turn an array of objects into an array of numbers from the ticketcount
        let data = [];
        let labels = [];
        let weekends = [];
        for (let i = 0; i < response.data.length; i++) {
          data.push(response.data[i].ticketcount);
          labels.push(response.data[i].day);
          // If isWeekend is true push 1 otherwise 0
          weekends.push(response.data[i].isWeekend ? 1 : 0);
        }
        that.series[0] = {
          data: data,
          name: "Tickets per day",
          type: "line",
        };
        that.chartOptions = {
          tooltip: {
            theme: "dark",
          },
          colors: ["#ba7bb6"],
          stroke: {
            curve: "smooth",
            width: 2,
          },
          chart: {
            id: "vuechart-example",
          },
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true,
            zoomedArea: {
              fill: {
                type: "gradient",
              },
            },
          },
          xaxis: {
            categories: labels,
            type: "datetime",
            labels: {
              formatter: function (val) {
                return moment(val).format("dddd - DD MMM YYYY");
              },
            },
          },
        };
      });
    },
    getSeriesData() {
      let that = this;
      axios.get("/api/v1/ticket/monthly-chart").then((response) => {
        that.series = response.data.data;
      });
    },
  },
  created() {
    this.getChartData();
  },
};
</script>

<style lang="scss" scoped></style>
